import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Gift, Cake } from "lucide-react";
import { http, euro } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const fmt = (iso) => new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });

export const Rewards = () => {
  const { user, setUser } = useAuth();
  const [birthdate, setBirthdate] = useState(user?.birthdate ?? "");
  const [coupons, setCoupons] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    http.get("/me/coupons").then((r) => setCoupons(Array.isArray(r.data) ? r.data : [])).catch(() => setCoupons([]));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await http.patch("/me/profile", { birthdate });
      setUser(data);
      toast.success("Date enregistrée : un cadeau vous attendra le jour J.");
    } catch {
      toast.error("Date invalide.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <section data-testid="rewards-section" className="mt-12 grid gap-4 sm:grid-cols-2">
      <form onSubmit={save} className="rounded-[20px] border border-[var(--line)] bg-white p-6">
        <Cake className="h-5 w-5 text-[var(--terra)]" />
        <h2 className="font-display mt-3 text-xl">-30 % pour votre anniversaire</h2>
        <p className="mt-1 text-sm text-[var(--muted)]">Indiquez votre date de naissance : le jour J, vous recevez un code par email, valable 30 jours.</p>
        <div className="mt-4 flex gap-2">
          <input type="date" required data-testid="birthdate-input" value={birthdate} onChange={(e) => setBirthdate(e.target.value)}
            className="min-w-0 flex-1 rounded-xl border border-[var(--line)] px-3 py-2.5 text-sm outline-none focus:border-[var(--ink)]" />
          <button data-testid="birthdate-save-button" disabled={saving || !birthdate}
            className="rounded-xl bg-[var(--ink)] px-4 text-sm text-[var(--bone)] hover:bg-[var(--terra)] disabled:opacity-50">Enregistrer</button>
        </div>
      </form>
      <div className="rounded-[20px] border border-[var(--line)] bg-white p-6">
        <Gift className="h-5 w-5 text-[var(--terra)]" />
        <h2 className="font-display mt-3 text-xl">Mes bons d'achat</h2>
        <p className="mt-1 text-sm text-[var(--muted)]">5 € offerts sur la commande suivante pour tout achat payé dès 40 €.</p>
        {coupons.length === 0 ? <p data-testid="no-coupons" className="mt-4 text-sm text-[var(--muted)]">Aucun bon actif pour le moment.</p> : (
          <ul className="mt-4 space-y-2">
            {coupons.map((c) => (
              <li key={c.code} data-testid={`coupon-${c.code}`} className="flex items-center justify-between rounded-xl bg-[var(--bone-2)] px-3 py-2 text-sm">
                <span className="font-mono-label text-xs">{c.code}</span>
                <span>{c.type === "percent" ? `-${c.value} %` : `-${euro(c.value)}`} · jusqu'au {fmt(c.expires_at)}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
};
